import React from "react";
import {
  Container,
  Row, Col,
  Card,
  CardBody,
  Button, Form,
  FormInput, FormGroup
} from "shards-react";

const ResetPassword = () => (
  <Container className="main-content-container h-100 px-4 container-fluid">
    <Row className="h-100 no-gutters">
      <Col className="auth-form mx-auto my-auto col-md-5 col-lg-4">
        <Card>
          <CardBody style={{ overflow: 'hidden',  boxShadow: 'inset 0 4px 0 0 #007bff', borderRadius: '.625rem' }}>
            <img className="auth-form__logo d-table mx-auto mb-3" src={require("../images/logo_login.png")}     alt="Galeno"  />
            <h5 className="auth-form__title text-center mb-4">Recuperar Contraseña</h5>
            <Form>
              <FormGroup>
                <label htmlFor="#email">Email</label>
                <FormInput type="email" id="#email" placeholder="Email" />
              </FormGroup>
              <Button className="d-table mx-auto btn-accent btn-pill">Recuperar</Button>
            </Form>
          </CardBody>
        </Card>
        <div className="auth-form__meta d-flex mt-4">
        <a href="/login" style={{     fontWeight: 400, color: '#818ea3' }}>Iniciar Session</a>
        </div>
      </Col>
    </Row>
  </Container>
);

export default ResetPassword;
